/**
 * Zudoku config for the public Zenith API docs (docs are public — no login).
 *
 * The API reference renders from the SAME hand-written spec the API serves
 * (server/assets/public-api/openapi-v1.yaml) — one source of truth.
 *
 * The interactive playground is disabled: the API intentionally sends no CORS
 * headers (server-to-server policy), so in-browser "try it" calls would fail.
 * To enable it later: flip disablePlayground and allow this docs origin in
 * server/middleware/public-api-auth.ts.
 */
import type { ZudokuConfig } from "zudoku"

const config: ZudokuConfig = {
  metadata: {
    title: "Zenith API",
    description: "Read-only API for your company's financial data — bank transactions, expenses, partners, and reports.",
    favicon: "/favicon.ico",
  },

  // Brand assets live in api-docs/public/ (served at the site root). The full
  // wordmark is navy (#1D1655) so it disappears on a dark header — the dark
  // variant swaps the wordmark to white and keeps the indigo mark (#382CA6).
  site: {
    logo: {
      src: {
        light: "/Zenith-Logo-Color.svg",
        dark:  "/Zenith-Logo-White.svg",
      },
      alt:   "Zenith",
      width: 110,
    },
    showPoweredBy: false,
  },

  sitemap: {
    siteUrl: "https://docs.zenith-books.com",
  },

  navigation: [
    {
      type: "category",
      label: "Documentation",
      icon: "book",
      items: [
        { type: "doc", file: "introduction",   label: "Introduction" },
        { type: "doc", file: "authentication", label: "Authentication" },
        { type: "doc", file: "conventions",    label: "Conventions & errors" },
        { type: "doc", file: "connect-claude", label: "Connect Claude (MCP)" },
      ],
    },
    { type: "link", to: "/api", label: "API Reference", icon: "code" },
  ],

  apis: {
    type: "file",
    input: "../server/assets/public-api/openapi-v1.yaml",
    path: "/api",
  },

  // The site has no landing page at "/"; send visitors to the first doc.
  redirects: [{ from: "/", to: "/introduction" }],

  defaults: {
    apis: {
      disablePlayground: true,
      examplesLanguage: "shell",
    },
  },
}

export default config
